import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ChatRoom from "./component/ChatContainer/ChatRoom";
import CreateRoom from "./component/ChatContainer/CreateRoom";
import JoinRoom from "./component/ChatContainer/JoinRoom";
import HomePage from "./component/ChatContainer/HomePage";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
      <Route path="/create" element={<CreateRoom />} />
      <Route path="/room/:roomId" element={<JoinRoom />} />
        <Route path="/room/:roomId/chat" element={<ChatRoom />} />
      </Routes>
    </Router>
  );
}

export default App;